/* eslint-disable */
// remember to expose flowplayer function want to use.
// if update this file, need refrash browser

import player from "./index";
import $store from '@/store/index';
import nativeVideoPlayer from './nativeVideo';

const useNativeVideo = () => nativeVideoPlayer.isEnabled();

const videoPlayer = (function () {
  // $store for search app and $store() for nuxt app
  const store = typeof $store === 'function' ? $store() : $store;

  let container = '#player';
  let playerEl;
  let videoEl;

  // let settings = {
  //   loop: true,
  //   autoplay: false,
  //   speed: 1,
  //   cuepoints: [],
  // };

  // detect browser support webM
  const supportsVideoType = (type) => {
    let videoDetector;

    // Allow user to create shortcuts, i.e. just "webm"
    const formats = {
      ogg: 'video/ogg; codecs="theora"',
      h264: 'video/mp4; codecs="avc1.42E01E"',
      webm: 'video/webm; codecs="vp8, vorbis"',
      vp9: 'video/webm; codecs="vp9"',
      hls: 'application/x-mpegURL; codecs="avc1.42E01E"',
    };

    if (!videoDetector) {
      videoDetector = document.createElement('video');
    }

    return videoDetector.canPlayType(formats[type] || type);
  };

  const isWebm = () => (supportsVideoType('webm') ? true : false);

  const videoFilter = (el) => {
    if (typeof el === 'object') {
      const sources = [];

      // mp4 is more stable for playback
      if (el.previews.mp4) {
        sources.push({
          type: 'video/mp4',
          src: el.previews.mp4.url,
        });
      }

      if (el.previews.webm) {
        sources.push({
          type: 'video/webm',
          src: el.previews.webm.url,
        });
      }

      return sources;
    }
    return {
      sources: [{
        type: el.match('webm') ? 'video/webm' : 'video/mp4',
        src: el,
      }],
    };
  };

  /**
   * @param {String} dom
   * @param {any} el
   */
  const init = (dom, el, options) => {
    if (useNativeVideo()) {
      return nativeVideoPlayer.init(dom, el, options);
    }
    // console.log('loop: ', settings.loop);
    // console.log('autoplay: ', settings.autoplay);
    if (dom) {
      container = dom;
    }
    if (el) {
      videoEl = el;
      store.commit('videoPlayer/setPlayerId', el.id);
    }
    playerEl = flowplayer(container, {
      engine: 'html5',
      key: (['production', 'stage'].indexOf(process.env.NODE_ENV) >= 0) ? process.env.VUE_APP_FLOWPLAYER_KEY : '',
      // debug: (['production', 'stage'].indexOf(process.env.NODE_ENV) < 0),
      debug: false,
      // cuepoints: set.cuepoints,
      aspectRatio: '16:9',
      preload: 'auto',
      loop: true,
      splash: true,
      autoplay: false,
      muted: false,
      share: false,
      clip: videoFilter(videoEl),
    })
    .on('ready', function (e, player) {
      console.log('[player/video/flowplayer] ready', e, player);
      store.commit('videoPlayer/setStatus', {
        type: 'ready',
        bool: true,
      });
    })
    .on('playing', function (e, player) {
      console.log('[player/video/flowplayer] playing');
      store.commit('videoPlayer/setStatus', {
        type: 'playing',
        bool: true,
      });
    })
    .on('resume', function (e, player) {
      // product page load & stop
      console.log('[player/video/flowplayer] resume');
      store.commit('videoPlayer/setStatus', {
        type: 'playing',
        bool: true,
      });
    })
    .on('pause', function (e, player) {
      console.log('[player/video/flowplayer] pause');
      store.commit('videoPlayer/setStatus', {
        type: 'pause',
        bool: true,
      });
    });
    // .on('stop', function (e, player) {
    //   console.log('[player/video/flowplayer] stop');
    // });
    // .on('ready', function (e, api) {
    //   console.log('[FP] player is ready', e, api);
    //   // update speed setting when init
    //   api.speed(settings.speed);
    //   // console.log('ready api', api);
    //   // update curpoint
    //   if (settings.cuepoints.length) {
    //     console.log('[FP] set cuepoints', e, settings.cuepoints);
    //     api.setCuepoints([{time: settings.cuepoints[0], type: 'in'}, {time: settings.cuepoints[1], type: 'out'}]);
    //     // api.addCuepoints([{time: settings.cuepoints[0], type: 'in'}, {time: settings.cuepoints[1], type: 'out'}]);
    //     if (settings.cuepoints[0] > 0) {
    //       // resume issue
    //       // https://github.com/flowplayer/flowplayer/issues/1411
    //       // api.resume().seek(settings.cuepoints[0]);
    //       api.seek(settings.cuepoints[0]);
    //     }
    //   }
    // }).on('cuepoint', function(e, api, cuepoint) {
    //   console.log('[FP] cuepoint', e, cuepoint);
    //   if (cuepoint.type == 'out') {
    //     // api.resume().seek(api.cuepoints[0].time);
    //     api.seek(api.cuepoints[0].time);
    //   }
    // }).on('cuepoints', function(e, api) {
    //   console.log('[FP] cuepoints', e);
    // }).on('cuepointstart', function(e, api) {
    //   console.log('[FP] cuepointstart', e);
    // }).on('cuepointend', function(e, api) {
    //   console.log('[FP] cuepointend', e);
    // });

    // if (!settings.autoplay) {
    //   stop();
    // } else {
    //   play();
    // }
    // stop();
    if (playerEl) {
      stop();
    }
  };

  const play = () => {
    if (useNativeVideo()) {
      return nativeVideoPlayer.play();
    }
    playerEl.load();
    playerEl.play();
  };

  const stop = () => {
    if (useNativeVideo()) {
      return nativeVideoPlayer.stop();
    }
    playerEl.stop();
  };

  const pause = () => {
    if (useNativeVideo()) {
      return nativeVideoPlayer.pause();
    }
    playerEl.pause();
  };

  /**
   * @param {Number} level
   */
  const volume = (level = 0) => {
    if (useNativeVideo()) {
      return nativeVideoPlayer.volume(level);
    }
    return playerEl.volume(level);
  };

  /**
   * @param {Boolean} toggle
   */
  const muted = (toggle = false) => {
    if (useNativeVideo()) {
      return nativeVideoPlayer.muted(toggle);
    }
    playerEl.muted = toggle;
  };

  /**
   * @param {Number} sec;
   */
  const seek = (sec) => {
    if (useNativeVideo()) {
      return nativeVideoPlayer.seek(sec);
    }
    playerEl.seekTo(sec);
  };

  /**
   * @param {Number} markIn;
   * @param {Number} markOut;
   */

  // const setCuePoints = (markIn, markOut) => {
  //   // playerEl.removeCuepoint();
  //   console.log('FP', 'setCuePoints', markIn, markOut);
  //   // playerEl.setCuepoints([{time: markIn, type: 'in'}, {time: markOut, type: 'out'}]);
  //   playerEl.addCuepoint([markIn, markOut]);
  //   console.log('FP', 'IN', playerEl.cuepoints[0].time);
  //   console.log('FP', 'OUT', playerEl.cuepoints[1].time);
  //   // console.log('FP', 'setCuePoints', playerEl.addCuepoint([markIn, markOut]));
  //   // playerEl.emit((
  //   //   flowplayer.event.CUEPOINTS,
  //   //   { cuepoints: playerEl.cuepoints.concat({start: markIn, end: markOut}) }
  //   // ));
  // }

  /**
   *
   * @param {Number} s
   */
  const speed = (s) => {
    if (useNativeVideo()) {
      return nativeVideoPlayer.speed(s);
    }
    // settings.speed = s;
    playerEl.speed(s);
  };

  /**
   *
   * @param {Boolean} toggle
   */
  // const loop = (toggle) => {
  //   settings.loop = toggle;
  // };

  /**
   *
   * @param {Boolean} toggle
   */
  // const autoplay = (toggle) => {
  //   settings.autoplay = toggle;
  // };

  const unload = () => {
    if (useNativeVideo()) {
      return nativeVideoPlayer.unload();
    }
    return playerEl.unload();
  };

  const shutdown = () => {
    if (useNativeVideo()) {
      return nativeVideoPlayer.shutdown();
    }
    return playerEl.shutdown();
  };

  /**
   *
   * @param {Object} payload
   */
  // const updateSettings = (payload) => {
  //   console.log('[FP] update settings: ', payload);
  //   settings = payload;
  //   console.log('[FP] player settings: ', settings);
  // };


  return {
    init,
    play,
    stop,
    pause,
    volume,
    muted,
    seek,
    // setCuePoints,
    speed,
    // loop,
    // autoplay,
    unload,
    shutdown,
    // updateSettings,
  };
}());

export default videoPlayer;
